import { BatchResource } from "../batch/types";
import { TemplateResource } from "../template/types";
import { FormResource, InputTypes } from "../form/types";
import { UserResource } from "../user/types";
import { Pagination } from "@/store";

export const REQUESTS_STATES = [
  { value: "pending", label: "Pendiente", color: "orange" },
  { value: "generated", label: "Generada", color: "primary" },
  { value: "signed", label: "Firmada", color: "success" }
];

export type CompanyResource = {
  id: string;
  type: "company";
  attributes: {
    id: string;
    name: string;
    rut: string;
  };
  meta: {
    created_at: string;
    updated_at: string;
  };
};

export type RequestResource = {
  id: string;
  type: "request";
  attributes: {
    id: string;
    state: number;
    variables: { name: string; value: string }[];
  };
  meta: {
    created_at: string;
    updated_at: string;
    templates_count: number;
    state: string;
  };
  relationships: {
    batch: {
      data: BatchResource;
    };
    user: {
      data: UserResource;
    };
    company: {
      data: CompanyResource;
    };
    templates: {
      data: TemplateResource[];
    };
    forms: {
      data: FormResource[];
    };
  };
};

export type GeneratePayload = {
  request: {
    forms_attributes: {
      id: string; // Form id
      data: { [key: string]: InputTypes };
    }[];
  };
};

export type RequestIndexResponse = {
  requests: {
    data: RequestResource[];
    included: (
      | UserResource
      | BatchResource
      | TemplateResource
      | FormResource
      | CompanyResource
    )[];
  };
  pagination: Pagination & { totalItems: number };
};

export type RequestShowResponse = {
  data: RequestResource;
  included: (
    | UserResource
    | BatchResource
    | TemplateResource
    | FormResource
    | CompanyResource
  )[];
};

export interface RequestState {
  requests: { [key: string]: RequestResource };
  requestsList: string[];
  selected?: RequestResource;
}
